import PhotoSwipeLightbox from '//cdn.shopify.com/s/files/1/0645/9064/3457/t/2/assets/photoswipe-lightbox.esm.js';
import PhotoSwipe from '//cdn.shopify.com/s/files/1/0645/9064/3457/t/2/assets/photoswipe.esm.js';

const lightbox = new PhotoSwipeLightbox({
  gallery: '.product-image-slider__body',
  children: 'a',
  pswpModule: PhotoSwipe,
  allowPanToNext: false,
  captionEl: false,
  closeOnScroll: false,
  counterEl: false,
  history: false,
  pinchToClose: false,
  preloaderEl: false,
  scaleMode: 'zoom',
  shareEl: false,
  tapToToggleControls: false,
});

lightbox.init();